moment = require 'moment'
PerformanceMetrics = require './metrics/performance'

class Utility

  @getClientConfig: ->
    Groupon.Getaways = Groupon.Getaways || {}
    Groupon.Getaways.ClientConfig = Groupon.Getaways.ClientConfig || {}
    Groupon.Getaways.ClientConfig.global = Groupon.Getaways.ClientConfig.global || {}
    Groupon.Getaways.ClientConfig.local = Groupon.Getaways.ClientConfig.local || {}
    Groupon.Getaways.ClientConfig

  @clientGlobalConfig: @getClientConfig().global
  @clientLocalConfig: @getClientConfig().local

  @parseSearchString: (urlString) ->
    searchString = urlString or window.location.search
    params = {}
    if searchString.length > 1
      searchString = searchString.substring(1)
      pattern = /([^&=]+)=?([^&]*)/g

      params[keyValue[1]] = decodeURIComponent(keyValue[2])  while keyValue = pattern.exec(searchString)

    params

  @rootUrl: ->
    @clientGlobalConfig.root_url

  @getSearchParametersFromURL: () ->
    urlSplit = location?.search?.split("?")
    return {} if urlSplit.length < 2
    queryString = urlSplit[1]
    hash = {}
    arr = ['check_in', 'check_out', 'destination_name', 'destination_id', 'latitude', 'longitude', 'radius', 'category']
    for el in arr
      match = queryString.match("#{el}=(.*?)(?:&|$)")
      hash[el] = decodeURIComponent(match[1]) if match && match.length > 1
    hash.city = hash.destination_name?.split(",")[0] if hash.destination_name?
    hash

  @translate: (key, hash = {}) ->
    TRANSALTION_PREFIX = "js.modules"
    I18n.translate "#{TRANSALTION_PREFIX}.#{key}", hash

  @translateFunction: (key)->
    I18n.translate(key, {scope: "js"})

  @getConfig: (param) ->
    @clientGlobalConfig[param]

  @getLocalConfigProperty: (param) ->
    @clientLocalConfig[param]

  @validatesUrlDate: (hash) ->
    return false if not (hash.check_in && hash.check_out)
    checkIn = @validateDate hash.check_in
    checkOut = @validateDate hash.check_out
    checkIn && checkOut && (checkOut > checkIn)

  @validatesDestinationId: (hash) ->
    hash.destination_id && $.trim(hash.destination_id) != ""

  @validateDate: (date) ->
    return undefined if not date
    curDate = new Date()
    curDate.setHours 0, 0, 0, 0
    daysLimit = (@getLocalConfigProperty "daysLimit") || 330
    daysLimit = daysLimit * 24 * 60 * 60 * 1000
    date = date.replace(/-/g, '/')
    if date is "" or isNaN(new Date(date).getTime())
      return undefined
    else
      date = new Date(date)
    date  if date and Date.parse(date) >= Date.parse(curDate) and date - curDate <= daysLimit

  @urlHashParameters =  () ->
    queryString = location.hash.split("?")
    return "" if not queryString[1]
    queryString[1]

  @getCategory: () ->
    categoryName = location.search.replace('?category=', '')
    category = $("#destination_filters li [data-category='#{categoryName}']").attr('data-title')
    {category}

  @isSearchPage: () ->
    not ( location.href.indexOf("function=search") == -1 and _.isEmpty(@getSearchParametersFromURL()) )

  # Finds the ?one=1&two=2&three=3 portion of a groupon itier url, where the urls are slightly non-standard.
  # Standard urls look like:
  #   example.com/pathname?name=value#fragment
  # but groupon urls look like:
  #   groupon.com/pathname#fragment?name=value
  # The fragment and query section are switched.
  # This function grabs the query portion and creates an object out of it, assuming it's the last thing in the
  # url. It decodes url escape codes as %20' -> ' ')
  # It returns an object containing the key/value pairs
  # Examples:
  #  'www.example.com?key1=value1&key2=value2' -> { key1: 'value1', key2: 'value2'}
  #  'www.example.com' -> {}
  @getQueryParams: (urlString) ->
    if urlString.indexOf('?') == -1
      return {}

    queryString = urlString?.split('?')[1] # Grab everything after the '?'
    keyValues = @getParams(queryString)

    keyValues

  @getParams: (paramString) ->
    decodedParamString = @decodeParams(paramString)
    keyValueStrings = decodedParamString?.split('&')

    keyValues = {}
    for keyValueString in keyValueStrings
      keyValuePair = keyValueString?.split('=')
      keyValues[keyValuePair[0]] = keyValuePair[1]

    keyValues

  # decodeURIComponent doesn't decode the '+', so I need to do this in two steps.
  @decodeParams: (params) ->
    replacedParams = params.replace(/\+/g, '%20') # replace all '+' with '%20'
    decodedUrl = window.decodeURIComponent(replacedParams)
    decodedUrl

  @initiatePageReady: () ->
    performanceMetrics = new PerformanceMetrics()
    performanceMetrics.pageReady()

  @parseUrlString = (hashString) ->
    params = null
    if hashString
      params = {}
      pattern = /([^&=]+)=?([^&]*)/gi
      decode = (s) ->
        s = s.replace(/\+/g, ' ')
        decodeURIComponent(s)
      while keyValue = pattern.exec(hashString)
        params[decode(keyValue[1])] = decode(keyValue[2])  if(keyValue[2]!= '')
    params

  @getCategoryFromQueryParam: () ->
    searchQueryMatch = window.location.search.match(/(\?|&)category=(.+)($|&)/)
    category = ""
    category = searchQueryMatch[2] if searchQueryMatch
    category

  @baseUrl: () ->
    @getLocalConfigProperty('baseUrl')

module.exports = Utility
